// courseSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  FETCH_COURSES_REQUEST,
  ADD_COURSE_REQUEST,
  UPDATE_COURSE_REQUEST,
  DELETE_COURSE_REQUEST,
  FETCH_COURSES_DROPDOWN_REQUEST,
} from './actionTypes';

import {
  fetchCoursesRequest,
  fetchCoursesSuccess,
  fetchCoursesFailure,
  addCourseSuccess,
  addCourseFailure,
  updateCourseSuccess,
  updateCourseFailure,
  deleteCourseSuccess,
  deleteCourseFailure,
  fetchCoursesDropdownSuccess,
  fetchCoursesDropdownFailure,
} from './actions';

import axiosInstance from 'pages/Utility/axiosInstance';
import { showSuccess } from 'helpers/notification_helper';

// API calls
const fetchCoursesApi = async (params) => {
  return await axiosInstance.get('V1/courses', { params });
};

const addCourseApi = async (course) => {
  return await axiosInstance.post('V1/courses', course);
};

const updateCourseApi = async ({ id, course }) => {
  return await axiosInstance.put(`V1/courses/${id}`, course);
};

const deleteCourseApi = async (courseId) => {
  return await axiosInstance.delete(`V1/courses/${courseId}`);
};

const fetchCoursesDropdownApi = async () => {
  return await axiosInstance.get('V1/courses/admin/dropdown');
};

// Fetch Courses
function* fetchCoursesSaga(action) {
  try {
    const response = yield call(fetchCoursesApi, action.payload);
    yield put(fetchCoursesSuccess(response.data));
  } catch (error) {
    yield put(fetchCoursesFailure(error.message));
  }
}

// Add Course
function* addCourseSaga(action) {
  try {
    const response = yield call(addCourseApi, action.payload.course);
    action.payload.onClose();
    yield put(addCourseSuccess(response.data));
    yield put(fetchCoursesRequest());

    showSuccess('Course added successfully!');
  } catch (error) {
    yield put(addCourseFailure(error?.response?.data?.errors));
  }
}

// Update Course
function* updateCourseSaga(action) {
  try {
    const response = yield call(updateCourseApi, action.payload);
    action.payload.onClose();
    yield put(updateCourseSuccess(response.data));
    showSuccess(response?.data?.message || 'Course updated successfully!');
    yield put({ type: "FETCH_COURSES_DROPDOWN_REQUEST" });
  } catch (error) {
    yield put(updateCourseFailure(error?.response?.data?.errors));
  }
}

// Delete Course
function* deleteCourseSaga(action) {
  try {
    const { data } = yield call(deleteCourseApi, action.payload);
    console.log(data);
    yield put(deleteCourseSuccess(data));
    showSuccess('Course deleted successfully!');
  } catch (error) {
    yield put(deleteCourseFailure(error.message));
  }
}

function* fetchCoursesDropdownSaga() {
  try {
      console.log(" fetchCoursesDropdownSaga triggered");
    const response = yield call(fetchCoursesDropdownApi);
    console.log(" Courses API success:", response);
    yield put(fetchCoursesDropdownSuccess(response.data));  
  } catch (error) {
    yield put(fetchCoursesDropdownFailure(error.message));
  }
}

// Watcher Saga
export default function* courseSaga() {
  yield takeLatest(FETCH_COURSES_REQUEST, fetchCoursesSaga);
  yield takeLatest(ADD_COURSE_REQUEST, addCourseSaga);
  yield takeLatest(UPDATE_COURSE_REQUEST, updateCourseSaga);
  yield takeLatest(DELETE_COURSE_REQUEST, deleteCourseSaga);
  yield takeLatest(FETCH_COURSES_DROPDOWN_REQUEST, fetchCoursesDropdownSaga);
}

